'use strict';

var toggleTasks = require('./toggleTasks');

function filterTaskByCategory ($marketingChecklist, category) {
  var $tasksList = $marketingChecklist.find('.marketing-checklist-list');
  var $tasks = $tasksList.find('.task-container');
  var showDone = category === 'done';

  $tasksList.removeClass('show-done show-todo');

  if (showDone) {
    $tasksList.addClass('show-done');
  } else {
    $tasksList.addClass('show-todo');
  }

  $tasks.removeClass('filtered-out');

  if (category !== 'all' && category !== 'done') {
    $tasks.each(function (index) {
      if ($(this).attr('data-category') !== category) {
        return $(this).addClass('filtered-out');
      }
    });
  }

  return toggleTasks($marketingChecklist);
}

module.exports = filterTaskByCategory;
